import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { environment } from '@env';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private loadingBar: LoadingBarService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let ignoredList = [environment.baseurl + '/api/clusters/estimate'];

    if (ignoredList.includes(request.url)) {
      return next.handle(request).pipe(finalize(() => {}));
    }

    this.loadingBar.start();
    return next.handle(request).pipe(
      finalize(() => {
        this.loadingBar.complete();
      })
    );
  }
}
